import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import * as S from '../../Form/DateInput/styled'

const dateBoundaries = date => {
    return {
        start: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0),
        end: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59),
    }
}

const DateRangeFilter = ({
    label,
    column,
    onApplyFilters,
    gotoPage,
    state,
    selectedFilters = [],
}) => {
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    const path = window.location.pathname
    const claims = window.localStorage.getItem('claims')
    const user = claims ? JSON.parse(claims)['id'] : ''

    useEffect(() => {
        let storedFilters = JSON.parse(window.localStorage.getItem(`${user}_filterValues${path}`))

        if (storedFilters && storedFilters[column.id]) {
            column.setFilter({
                before: storedFilters[column.id]['before'],
                after: storedFilters[column.id]['after'],
            })

            setStartDate(new Date(storedFilters[column.id]['after']))
            setEndDate(new Date(storedFilters[column.id]['before']))
        }
    }, [])

    useEffect(() => {
        if (startDate && endDate) {
            column.setFilter({
                before: endDate.toISOString(),
                after: startDate.toISOString(),
            })
        }
    }, [startDate, endDate])

    useEffect(() => {
        // Clear filters on reset
        if (Object.keys(state[0].filters).length === 0) {
            setStartDate(null)
            setEndDate(null)
        }
    }, [state[0].filters])

    function handleBlur() {
        if (startDate && endDate) {
            onApplyFilters()
            gotoPage(0)
        }
    }

    return (
        <>
            {selectedFilters[column.id] && (
                <S.DatePickerInput className="form-group !mb-2 lg:!mb-0 lg:!mr-2">
                    <label>{label}</label>
                    <S.DatePickerContainer className="form-row">
                        <div className="col-12 col-xl-6 !mb-2 xl:!mb-0">
                            <DatePicker
                                className="datepicker__start-date form-control"
                                placeholderText="Start Date"
                                dateFormat="dd/MM/yyyy"
                                selected={startDate}
                                onChange={date => {
                                    const start = new Date(date).getTime()
                                    const end = new Date(endDate).getTime()
                                    setStartDate(dateBoundaries(date).start)

                                    if (!endDate || start > end) {
                                        setEndDate(dateBoundaries(date).end)
                                    }
                                }}
                                onBlur={handleBlur}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                            />
                        </div>
                        <div className="col-12 col-xl-6">
                            <DatePicker
                                className="datepicker__end-date form-control"
                                placeholderText="End Date"
                                dateFormat="dd/MM/yyyy"
                                selected={endDate}
                                onChange={date => setEndDate(dateBoundaries(date).end)}
                                onBlur={handleBlur}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                            />
                        </div>
                    </S.DatePickerContainer>
                </S.DatePickerInput>
            )}
        </>
    )
}

DateRangeFilter.propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    column: PropTypes.shape({
        filterValue: PropTypes.object,
        setFilter: PropTypes.func.isRequired,
    }),
    onApplyFilters: PropTypes.func.isRequired,
}

export default DateRangeFilter
